module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/rotate-auto-ff1265c942cc2266178439253abcd5c0.svg";